/**
 * Der Pfad, an dem der Nutzer gerade steht — für Fehlerberichte.
 *
 * Die mQorva-Frontends laufen im HashRouter; steht ein Hash an, ist er der echte Pfad,
 * sonst gilt der Pfad der Adresse. Außerhalb des Browsers (SSR, Tests) gibt es keinen.
 */
export const getCurrentPath = (): string | null => {
  if (typeof window === "undefined") return null;
  return window.location.hash ? window.location.hash.replace(/^#/, "") || "/" : window.location.pathname;
};
